// Pure context + hook for preferences. Kept in a non-tsx file so the matching
// Provider component can stay component-only and play nice with React Fast Refresh.
import { createContext, useContext } from 'react';
import type { Preferences } from '@/hooks/usePreferences';

export interface PreferencesContextType {
  preferences: Preferences;
  updatePreferences: (preferences: Partial<Preferences>) => Promise<void>;
  isLoading: boolean;
}

export const PreferencesContext = createContext<PreferencesContextType | undefined>(undefined);

export function usePreferencesContext() {
  const context = useContext(PreferencesContext);
  if (context === undefined) {
    throw new Error('usePreferencesContext must be used within a PreferencesProvider');
  }
  return context;
}
